'use strict';

var lodash = require('lodash');
var angular = require('angular');

var app = angular.module('app');

var fnAnimateScroll = lodash.debounce(function (el, posObject, delay) {
    var d = lodash.isNumber(delay) ? delay : 500;

    el.animate(posObject, d);
}, 50);

function Scroll($window) {
    var self = this;
    var elBody = document.body;

    this.scrollTop = function (pos, delay) {
        var posObject = {
            scrollTop: pos || 0
        };

        // Animate scroll
        fnAnimateScroll(elBody, posObject, delay);
    };

    // Scroll to element - account for xs-padding top
    this.scrollToElement = function (element, delay) {
        const rect = element.getBoundingClientRect();
        this.scrollTop((rect.top + document.body.scrollTop) - 65, delay);
    };

    this.scrollToHash = function (parentElement, hashParam) {
        var element;
        var hash = hashParam || $window.location.hash;

        if (hash) {
            element = parentElement.find(hash);

            if (element.length > 0) {
                self.scrollToElement(element, 0);
            }
        }
    };
}
app.service('Scroll', Scroll);
